import React from "react";
import classes from "./facebookPage.module.css";
import mergeClassNames from "merge-class-names";

function FacebookPage({
  className,
  label,
  url,
  ...restProps
}: {
  className: string;
  label: string;
  url: string;
}) {
  return (
    <div className={mergeClassNames(classes.root, className)}>
      <h3>{label}</h3>
      <div className={classes.postContainer}>
        {process.env.NODE_ENV && process.env.NODE_ENV !== "development" ? (
          <div
            className="fb-post"
            data-href={url}
            data-width="100%"
            data-show-text="true"
            {...restProps}
          />
        ) : null}
      </div>
    </div>
  );
}

export default FacebookPage;
